import React, { useState } from 'react';
import Modal from './Modal';

// Ortak onayla / reddet modalı.
// - "Reddet" seçilirse RedNedeni zorunludur (backend kuralı: en az 10 karakter).
// - onKarar(onayla: boolean, redNedeni: string|null) çağrılır.
export default function OnayModal({ baslik, aciklama, onKarar, onKapat }) {
  const [mod, setMod] = useState(null); // 'onay' | 'red'
  const [neden, setNeden] = useState('');
  const [gonderiliyor, setGonderiliyor] = useState(false);
  const [hata, setHata] = useState('');

  const redGecerli = neden.trim().length >= 10;

  async function calistir(onayla) {
    setHata('');
    if (!onayla && !redGecerli) {
      setHata('Red nedeni en az 10 karakter olmalıdır.');
      return;
    }
    setGonderiliyor(true);
    try {
      await onKarar(onayla, onayla ? null : neden.trim());
    } catch (e) {
      setHata(e.message || 'İşlem başarısız.');
      setGonderiliyor(false);
    }
  }

  return (
    <Modal baslik={baslik} onKapat={gonderiliyor ? () => {} : onKapat}>
      {aciklama && <p style={{ marginBottom: 16, color: '#555', fontSize: 14 }}>{aciklama}</p>}
      {hata && <div className="mesaj hata">{hata}</div>}

      {mod !== 'red' && (
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn btn-success" disabled={gonderiliyor} onClick={() => calistir(true)}>
            {gonderiliyor ? 'İşleniyor…' : '✓ Onayla'}
          </button>
          <button className="btn btn-danger" disabled={gonderiliyor} onClick={() => setMod('red')}>
            ✕ Reddet
          </button>
          <button className="btn btn-gray" disabled={gonderiliyor} onClick={onKapat}>
            İptal
          </button>
        </div>
      )}

      {mod === 'red' && (
        <div>
          <div className="form-group">
            <label>Red nedeni (zorunlu, en az 10 karakter)</label>
            <textarea
              rows={3}
              value={neden}
              autoFocus
              onChange={(e) => setNeden(e.target.value)}
              placeholder="Örn: Vergi numarası doğrulanamadı, bilgiler eksik."
            />
            <div style={{ fontSize: 12, color: redGecerli ? '#16a34a' : '#999', marginTop: 4 }}>
              {neden.trim().length}/10
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-danger" disabled={gonderiliyor || !redGecerli} onClick={() => calistir(false)}>
              {gonderiliyor ? 'İşleniyor…' : 'Reddet'}
            </button>
            <button className="btn btn-gray" disabled={gonderiliyor} onClick={() => setMod(null)}>
              Geri
            </button>
          </div>
        </div>
      )}
    </Modal>
  );
}
